import axiosInstance from '../../../../config/axiosInstance';
const  SettingService = {
    async GetAllSetting(redirectCallback) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetSetting?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async GetSettingByID(redirectCallback,ID) {
        try {            
            
            const response = await axiosInstance.get(`/Setup/GetSettingByID?ID=${ID}`);
            return response.data[0];
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async DeleteSetting(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Setup/DeleteSetting?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default SettingService;